"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLivestreamEndDateProperty = exports.livestreamEndDatePropertyDefinition = void 0;
exports.livestreamEndDatePropertyDefinition = {
    view: { label: 'End date' },
    constraints: [],
    type: 'date-time',
    multiple: false,
    name: 'livestream-end-date',
};
const isLivestreamEndDateProperty = (prop) => {
    return prop.name === exports.livestreamEndDatePropertyDefinition.name;
};
exports.isLivestreamEndDateProperty = isLivestreamEndDateProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGl2ZXN0cmVhbS1lbmQtZGF0ZS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2xpdmVzdHJlYW0tZW5kLWRhdGUucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxtQ0FBbUMsR0FBRztJQUNqRCxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsVUFBVSxFQUFFO0lBQzNCLFdBQVcsRUFBRSxFQUFFO0lBQ2YsSUFBSSxFQUFFLFdBQVc7SUFDakIsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUscUJBQXFCO0NBQ0ksQ0FBQTtBQUkxQixNQUFNLDJCQUEyQixHQUFHLENBQUMsSUFBa0IsRUFBcUMsRUFBRTtJQUNuRyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssMkNBQW1DLENBQUMsSUFBSSxDQUFBO0FBQy9ELENBQUMsQ0FBQTtBQUZZLFFBQUEsMkJBQTJCLCtCQUV2QyJ9